export const DRAW_EDIT_REINIT = 'DRAW_EDIT_REINIT';
export const DRAW_EDIT_GET_EVENT = 'DRAW_EDIT_GET_EVENT';
export const DRAW_EDIT_GET_EVENT_SUCCESS = 'DRAW_EDIT_GET_EVENT_SUCCESS';
export const DRAW_EDIT_GET_EVENT_FAILURE = 'DRAW_EDIT_GET_EVENT_FAILURE';
export const DRAW_EDIT_GET_CLUB = 'DRAW_EDIT_GET_CLUB';
export const DRAW_EDIT_GET_CLUB_SUCCESS = 'DRAW_EDIT_GET_CLUB_SUCCESS';
export const DRAW_EDIT_GET_CLUB_FAILURE = 'DRAW_EDIT_GET_CLUB_FAILURE';
export const DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS = 'DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS';
export const DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_SUCCESS = 'DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_SUCCESS';
export const DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_FAILURE = 'DRAW_EDIT_GET_CLUB_OFFICIAL_MEMBERS_FAILURE';
export const DRAW_EDIT_GET_DRAWS = 'DRAW_EDIT_GET_DRAWS';
export const DRAW_EDIT_GET_DRAWS_SUCCESS = 'DRAW_EDIT_GET_DRAWS_SUCCESS';
export const DRAW_EDIT_GET_DRAWS_FAILURE = 'DRAW_EDIT_GET_DRAWS_FAILURE';
export const DRAW_EDIT_GET_PLAYERS = 'DRAW_EDIT_GET_PLAYERS';
export const DRAW_EDIT_GET_PLAYERS_SUCCESS = 'DRAW_EDIT_GET_PLAYERS_SUCCESS';
export const DRAW_EDIT_GET_PLAYERS_FAILURE = 'DRAW_EDIT_GET_PLAYERS_FAILURE';
export const DRAW_EDIT_REBUILD_PLAYER_DICTS = 'DRAW_EDIT_REBUILD_PLAYER_DICTS';
export const DRAW_EDIT_GET_TEAMS = 'DRAW_EDIT_GET_TEAMS';
export const DRAW_EDIT_GET_TEAMS_SUCCESS = 'DRAW_EDIT_GET_TEAMS_SUCCESS';
export const DRAW_EDIT_GET_TEAMS_FAILURE = 'DRAW_EDIT_GET_TEAMS_FAILURE';
export const DRAW_EDIT_ADD_TO_DRAW = 'DRAW_EDIT_ADD_TO_DRAW';
export const DRAW_EDIT_REMOVE_FROM_DRAW = 'DRAW_EDIT_REMOVE_FROM_DRAW';
export const DRAW_EDIT_ADD_TO_MATCH = 'DRAW_EDIT_ADD_TO_MATCH';
export const DRAW_EDIT_CREATE_TEAM = 'DRAW_EDIT_CREATE_TEAM';
export const DRAW_EDIT_ADD_TEAM_TO_EVENT = 'DRAW_EDIT_ADD_TEAM_TO_EVENT';
export const DRAW_EDIT_SPLIT_TEAMS = 'DRAW_EDIT_SPLIT_TEAMS';
export const DRAW_EDIT_SET_SELECTED = 'DRAW_EDIT_SET_SELECTED';
export const DRAW_EDIT_SET_SELECTED_ND = 'DRAW_EDIT_SET_SELECTED_ND';
export const DRAW_EDIT_SET_SELECTED_TEAMS = 'DRAW_EDIT_SET_SELECTED_TEAMS';
export const DRAW_EDIT_SET_SELECTED_TEAMS_ND = 'DRAW_EDIT_SET_SELECTED_TEAMS_ND';
export const DRAW_EDIT_SET_PREVENT_SELECT_MOVE = 'DRAW_EDIT_SET_PREVENT_SELECT_MOVE';
export const DRAW_EDIT_ORDER_PLAYERS = 'DRAW_EDIT_ORDER_PLAYERS';
export const DRAW_EDIT_CREATE_DRAW = 'DRAW_EDIT_CREATE_DRAW';
export const DRAW_EDIT_AUTOFILL = 'DRAW_EDIT_AUTOFILL';
export const DRAW_EDIT_AUTOFILL_SUCCESS = 'DRAW_EDIT_AUTOFILL_SUCCESS';
export const DRAW_EDIT_AUTOFILL_FAILURE = 'DRAW_EDIT_AUTOFILL_FAILURE';
export const DRAW_EDIT_SET_PLAYER_STATUS = 'DRAW_EDIT_SET_PLAYER_STATUS';
export const DRAW_EDIT_SET_DRAW_TAG = 'DRAW_EDIT_SET_DRAW_TAG';
export const DRAW_EDIT_SET_DRAW_TAG_SUCCESS = 'DRAW_EDIT_SET_DRAW_TAG_SUCCESS';
export const DRAW_EDIT_SAVE = 'DRAW_EDIT_SAVE';
export const DRAW_EDIT_SAVE_SUCCESS = 'DRAW_EDIT_SAVE_SUCCESS';
export const DRAW_EDIT_SAVE_FAILURE = 'DRAW_EDIT_SAVE_FAILURE';
export const DRAW_EDIT_PUBLISH = 'DRAW_EDIT_PUBLISH';
export const DRAW_EDIT_PUBLISH_SUCCESS = 'DRAW_EDIT_PUBLISH_SUCCESS';
export const DRAW_EDIT_PUBLISH_FAILURE = 'DRAW_EDIT_PUBLISH_FAILURE';
export const DRAW_EDIT_SAVE_SUCCESS_HIDE = 'DRAW_EDIT_SAVE_SUCCESS_HIDE';
export const DRAW_EDIT_GET_MATCH_SUCCESS = 'DRAW_EDIT_GET_MATCH_SUCCESS';
export const DRAW_EDIT_UPDATE_SCHEDULE_TYPE = 'DRAW_EDIT_UPDATE_SCHEDULE_TYPE';
export const DRAW_EDIT_SET_RESET_TIMER = 'DRAW_EDIT_SET_RESET_TIMER';
export const DRAW_EDIT_SET_SAVING_FLAG = 'DRAW_EDIT_SET_SAVING_FLAG';
// -----------------------
export const DRAW_EDIT_GET_ACCEPTANCE_LIST = 'DRAW_EDIT_GET_ACCEPTANCE_LIST';
export const DRAW_EDIT_GET_ACCEPTANCE_LIST_SUCCESS = 'DRAW_EDIT_GET_ACCEPTANCE_LIST_SUCCESS';
export const DRAW_EDIT_GET_ACCEPTANCE_LIST_FAILURE = 'DRAW_EDIT_GET_ACCEPTANCE_LIST_FAILURE';
export const DRAW_EDIT_GET_ORGANIZER_RATINGS_SUCCESS = 'DRAW_EDIT_GET_ORGANIZER_RATINGS_SUCCESS';
export const DRAW_EDIT_SET_ORGANIZER_RATINGS_SUCCESS = 'DRAW_EDIT_SET_ORGANIZER_RATINGS_SUCCESS';
export const DRAW_EDIT_GET_DRAW = 'DRAW_EDIT_GET_DRAW';
export const DRAW_EDIT_GET_DRAW_SUCCESS = 'DRAW_EDIT_GET_DRAW_SUCCESS';
export const DRAW_EDIT_GET_DRAW_FAILURE = 'DRAW_EDIT_GET_DRAW_FAILURE';
export const DRAW_EDIT_SET_PLAYER_WILDCARD = 'DRAW_EDIT_SET_PLAYER_WILDCARD';
export const DRAW_EDIT_SET_PLAYER_WILDCARD_SUCCESS = 'DRAW_EDIT_SET_PLAYER_WILDCARD_SUCCESS';
export const DRAW_EDIT_SET_PLAYER_WILDCARD_FAILURE = 'DRAW_EDIT_SET_PLAYER_WILDCARD_FAILURE';
export const DRAW_EDIT_LOCATIONS_FETCH_REQUEST = 'DRAW_EDIT_LOCATIONS_FETCH_REQUEST';
export const DRAW_EDIT_LOCATIONS_FETCH_FAILURE = 'DRAW_EDIT_LOCATIONS_FETCH_FAILURE';
export const DRAW_EDIT_LOCATIONS_FETCH_SUCCESS = 'DRAW_EDIT_LOCATIONS_FETCH_SUCCESS';
export const DRAW_EDIT_FACILITIES_FETCH_REQUEST = 'DRAW_EDIT_FACILITIES_FETCH_REQUEST';
export const DRAW_EDIT_FACILITIES_FETCH_FAILURE = 'DRAW_EDIT_FACILITIES_FETCH_FAILURE';
export const DRAW_EDIT_FACILITIES_FETCH_SUCCESS = 'DRAW_EDIT_FACILITIES_FETCH_SUCCESS';
export const DRAW_EDIT_LOCATIONS_EXCLUDE_REQUEST = 'DRAW_EDIT_LOCATIONS_EXCLUDE_REQUEST';
export const DRAW_EDIT_LOCATIONS_EXCLUDE_SUCCESS = 'DRAW_EDIT_LOCATIONS_EXCLUDE_SUCCESS';
export const DRAW_EDIT_LOCATIONS_EXCLUDE_FAILURE = 'DRAW_EDIT_LOCATIONS_EXCLUDE_FAILURE';
export const DRAW_EDIT_OFFICIALS_FETCH_REQUEST = 'DRAW_EDIT_OFFICIALS_FETCH_REQUEST';
export const DRAW_EDIT_OFFICIALS_FETCH_SUCCESS = 'DRAW_EDIT_OFFICIALS_FETCH_SUCCESS';
export const DRAW_EDIT_OFFICIALS_FETCH_FAILURE = 'DRAW_EDIT_OFFICIALS_FETCH_FAILURE';
export const DRAW_EDIT_GET_DRAW_OFFICIALS_REQUEST = 'DRAW_EDIT_GET_DRAW_OFFICIALS_REQUEST';
export const DRAW_EDIT_GET_DRAW_OFFICIALS_SUCCESS = 'DRAW_EDIT_GET_DRAW_OFFICIALS_SUCCESS';
export const DRAW_EDIT_GET_DRAW_OFFICIALS_FAILURE = 'DRAW_EDIT_GET_DRAW_OFFICIALS_FAILURE';
export const DRAW_EDIT_DELETE_MATCH_OFFICIAL_REQUEST = 'DRAW_EDIT_DELETE_MATCH_OFFICIAL_REQUEST';
export const DRAW_EDIT_DELETE_MATCH_OFFICIAL_SUCCESS = 'DRAW_EDIT_DELETE_MATCH_OFFICIAL_SUCCESS';
export const DRAW_EDIT_DELETE_MATCH_OFFICIAL_FAILURE = 'DRAW_EDIT_DELETE_MATCH_OFFICIAL_FAILURE';
export const DRAW_EDIT_FETCH_MATCH_SHEET_SUCCESS = 'DRAW_EDIT_FETCH_MATCH_SHEET_SUCCESS';
export const DRAW_EDIT_DRAW_CONTACTS_SUCCESS = 'DRAW_EDIT_DRAW_CONTACTS_SUCCESS';
export const DRAW_EDIT_EDIT_TEAM_STANDING_SUCCESS = 'DRAW_EDIT_EDIT_TEAM_STANDING_SUCCESS';
export const DRAW_EDIT_DELETE_TEAM_STANDING_SUCCESS = 'DRAW_EDIT_DELETE_TEAM_STANDING_SUCCESS';
export const DRAW_EDIT_EVENT_TEAM_STANDINGS_SUCCESS = 'DRAW_EDIT_EVENT_TEAM_STANDINGS_SUCCESS';
export const DRAW_EDIT_ADD_TEAM_STANDING_SUCCESS = 'DRAW_EDIT_ADD_TEAM_STANDING_SUCCESS';
export const DRAW_EDIT_UPDATE_MATCH_SHEET_REQUEST = 'DRAW_EDIT_UPDATE_MATCH_SHEET_REQUEST';
export const DRAW_EDIT_UPDATE_MATCH_SHEET_SUCCESS = 'DRAW_EDIT_UPDATE_MATCH_SHEET_SUCCESS';
export const DRAW_EDIT_UPDATE_MATCH_SHEET_FAILURE = 'DRAW_EDIT_UPDATE_MATCH_SHEET_FAILURE';
export const DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_REQUEST = 'DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_REQUEST';
export const DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_SUCCESS = 'DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_SUCCESS';
export const DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_FAILURE = 'DRAW_EDIT_UPDATE_MATCH_SHEET_ROUND_FAILURE';
export const DRAW_EDIT_DELETE_MATCH_SHEET_SUCCESS = 'DRAW_EDIT_DELETE_MATCH_SHEET_SUCCESS';
export const DRAW_EDIT_GET_ORDER_OF_PLAY_SUCCESS = 'DRAW_EDIT_GET_ORDER_OF_PLAY_SUCCESS';
export const DRAW_EDIT_SAVE_ORDER_OF_PLAY_SUCCESS = 'DRAW_EDIT_SAVE_ORDER_OF_PLAY_SUCCESS';
export const DRAW_EDIT_DELETE_ORDER_OF_PLAY_SUCCESS = 'DRAW_EDIT_DELETE_ORDER_OF_PLAY_SUCCESS';
export const DRAW_EDIT_GET_ORDER_OF_PLAY_MATCHES_SUCCESS = 'DRAW_EDIT_GET_ORDER_OF_PLAY_MATCHES_SUCCESS';
export const DRAW_EDIT_OFFICIALS_UPDATE_REQUEST = 'DRAW_EDIT_OFFICIALS_UPDATE_REQUEST';
export const DRAW_EDIT_OFFICIALS_UPDATE_SUCCESS = 'DRAW_EDIT_OFFICIALS_UPDATE_SUCCESS';
export const DRAW_EDIT_OFFICIALS_UPDATE_FAILURE = 'DRAW_EDIT_OFFICIALS_UPDATE_FAILURE';
export const DRAW_EDIT_GET_MATCH_OFFICIALS_REQUEST = 'DRAW_EDIT_GET_MATCH_OFFICIALS_REQUEST';
export const DRAW_EDIT_GET_MATCH_OFFICIALS_SUCCESS = 'DRAW_EDIT_GET_MATCH_OFFICIALS_SUCCESS';
export const DRAW_EDIT_GET_MATCH_OFFICIALS_FAILURE = 'DRAW_EDIT_GET_MATCH_OFFICIALS_FAILURE';
export const DRAW_EDIT_ADD_MATCH_OFFICIAL_REQUEST = 'DRAW_EDIT_ADD_MATCH_OFFICIAL_REQUEST';
export const DRAW_EDIT_ADD_MATCH_OFFICIAL_FAILURE = 'DRAW_EDIT_ADD_MATCH_OFFICIAL_FAILURE';
export const DRAW_EDIT_UPDATE_DRAWS = 'DRAW_EDIT_UPDATE_DRAWS';
export const DRAW_EDIT_SET_MOVE_FAILED_PLAYERS = 'DRAW_EDIT_SET_MOVE_FAILED_PLAYERS';
export const DRAW_EDIT_GET_DRAW_DIVISION_ASSOCIATION_SUCCESS = 'DRAW_EDIT_GET_DRAW_DIVISION_ASSOCIATION_SUCCESS';
export const DRAW_EDIT_UPDATE_CHECK_IN_STATUS_SUCCESS = 'DRAW_EDIT_UPDATE_CHECK_IN_STATUS_SUCCESS';
export const DRAW_EDIT_CONFIRM_DIVISION_DRAW_ASSOCIATION_SUCCESS = 'DRAW_EDIT_CONFIRM_DIVISION_DRAW_ASSOCIATION_SUCCESS';
export const DRAW_EDIT_GET_DRAWS_PUBLISH_INFO_SUCCESS = 'DRAW_EDIT_GET_DRAWS_PUBLISH_INFO_SUCCESS';
export const DRAW_EDIT_TOGGLE_SMS_FLAG = 'DRAW_EDIT_TOGGLE_SMS_FLAG';
